import { TITLE_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Section implements TicketElement {
  text: string
  paddingTop: number
  paddingBottom: number
  boxHeight: number

  constructor(text: string) {
    this.text = text
    this.paddingTop = 30
    this.paddingBottom = 20
    this.boxHeight = 48
  }

  height(): number {
    return this.paddingTop + this.boxHeight + this.paddingBottom
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top, width, this.boxHeight)
    ctx.font = `bold 20px ${TITLE_FONT}`
    ctx.fillStyle = 'white'
    ctx.textBaseline = 'middle'
    ctx.textAlign = 'left'
    ctx.fillText(this.text, 15, top + this.boxHeight / 2)
  }
}
